import axios from "axios";

const estabelecimentoApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND}/estabelecimento`
})

async function servGetEstabelecimentos(estabelecimentoNome, estabelecimentosVigentes, apenasQueEnviamRelatorio) {

    const { data } = await estabelecimentoApi.get('', {
        params: { estabelecimentoNome, estabelecimentosVigentes, apenasQueEnviamRelatorio }
    })

    return data
}

// async function servGetEstabelecimentoPorNome(nomeEstabelecimento, somenteAtivos, enviaRelatorioAcompanhamento) {

//     const response = await estabelecimentoApi.get('por-nome', {
//         params: { nomeEstabelecimento, somenteAtivos, enviaRelatorioAcompanhamento }
//     })

//     return response.data
// }

export {
    servGetEstabelecimentos
    // ,servGetEstabelecimentoPorNome
}